import { useState, useEffect, ReactNode, RefObject } from 'react';

interface ScrollToBottomProps {
  enabled: boolean;
  trigger: ReactNode | number;
  scrollRef: RefObject<HTMLDivElement>;
}

export const useScrollToBottom = ({ enabled = true, scrollRef, trigger }: ScrollToBottomProps) => {
  const [prevHeight, setPervHeight] = useState(0);
  useEffect(() => {
    if (enabled && scrollRef.current) {
      const height = scrollRef.current.scrollHeight;
      if (prevHeight > 0 && height > prevHeight) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
      setPervHeight(height);
    }
  }, [enabled, trigger, scrollRef, prevHeight]);
};
